export function isUuidV4(id) {
  const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidV4Regex.test(id);
}

export function isIntegerString(str) {
  return /^[0-9]+$/.test(str);
}

export function isId(id) {
  return isUuidV4(id) || isIntegerString(id);
}
